import { Injectable } from '@angular/core';
import { LogService } from '../../../../shared/services/log.service';
import { DiversInitialService } from './formDiversInital/divers-initial.service';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { Annonce } from '../../../common/models/annonce';
import { StatutAvisEnum } from '../../../../../models/enums/statut-avis.enum';
import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { ChampsLibresTexteDate } from '../models/ChampsLibresTexteDate';
import { ChampsLibresTexte } from '../models/ChampsLibresTexte';
import { CommonService } from '../../../common/services/common/common.service';
import { DiversService } from '../../common/services/divers/divers.service';
import { DIVERS } from '../../common/models/Typedivers';
import { TypeAvisEnum } from '../../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { TypeLotsDivers } from '../models/TypeLotsDivers';

@Injectable({
  providedIn: 'root'
})
export class FormDiversInitalExtractorService {

  private LOG: LogService = new LogService(FormDiversInitalExtractorService);

  constructor(private formExtractorService: FormExtractorService,
              private diversService: DiversService,
              private commonService: CommonService,
              private diversInitialService: DiversInitialService,
              private avisDataTransferService: AvisDataTransferService) {
  }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.diversInitialService.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

    const initial = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.initial;

    if (stepId == 1) {
      initial.avisConcerne = this.diversInitialService.avisConcerneService.getAvisConcerne(controls);
    }

    if (stepId == 2) {
      initial.description = this.diversInitialService.descriptionService.getDescription(controls, this.diversInitialService.formExtractorService);
    }

    if (stepId == 3) {
      initial.marcheUnique = controls.get('_SepSep_TypeAnn_DIVER_G1_SepAtt_marcheUnique');
      initial.principales = new ChampsLibresTexte();
      initial.principales.txtLibre = {champsLibre: []};
      initial.principales.txtLibre.champsLibre[0] = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexte_SepSep_ChampLibreGroup_SepAtt_champsLibre');
      if (!initial.principales.txtLibre.champsLibre[0]?.trim() || initial.principales.txtLibre.champsLibre[0].length < 5) {
        initial.principales.txtLibre.champsLibre = [];
      }
      initial.principales.intLibre.intituleLibre = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexte_SepSep_IntituleLibreGroup_SepAtt_intituleLibre'));
      initial.principales.intLibre.intituleLibreLibelle = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexte_SepSep_IntituleLibreGroup_SepAtt_intituleLibreLibelle'));
      initial.principales.intLibre.intituleLibreLibelle = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexte_SepSep_IntituleLibreGroup_SepAtt_intituleLibreLibelle'));
    }
    if (stepId == 4) {
      if (initial.marcheUnique === 'Non' || initial.marcheUnique === null) {
        initial.lots = new TypeLotsDivers();
      } else {
        initial.lots = this.diversInitialService.lotsService.getLots(controls, this.formExtractorService);
      }
    }

    if (stepId == 5) {
      initial.delais = this.diversInitialService.delaiService.getDelais(controls);
      initial.procedure = new ChampsLibresTexteDate();
      initial.procedure.txtLibre = {champsLibre: []};
      initial.procedure.txtLibre.champsLibre[0] = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexteDate_SepSep_ChampLibreGroup_SepAtt_champsLibre'));
      if (!initial.procedure.txtLibre.champsLibre[0]?.trim() || initial.procedure.txtLibre.champsLibre[0].length < 5) {
        initial.procedure.txtLibre.champsLibre = [];
      }
      initial.procedure.intLibre.intituleLibre = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexteDate_SepSep_IntituleLibreGroup_SepAtt_intituleLibre'));
      initial.procedure.intLibre.intituleLibreLibelle = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexteDate_SepSep_IntituleLibreGroup_SepAtt_intituleLibreLibelle'));
      initial.procedure.dateLibre.intitule = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexteDate_SepSep_DateLibreGroup_SepAtt_intitule'));
      initial.procedure.dateLibre.dateHeureLibre = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_ChampsLibresTexteDate_SepSep_DateLibreGroup_SepAtt_dateHeureLibre'));
    }

    if (stepId == 6) {
      initial.rens_Complt = this.diversInitialService.rensComplService.getRensComplt(controls, this.diversInitialService.formExtractorService);
    }

    const divers: DIVERS = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers;
    if (stepId == 1) {
      divers.organisme = this.diversService.typeAdresseCompleteObligatoireService.getTypeAdresseCompleteObligatoire(controls);
    }
    divers.initial = initial;
    divers.attribution = null;
    divers.rectificatif = null;
    divers.annulation = null;

    const annonce: Annonce = new Annonce();
    annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = divers;
    annonce.ann.mapa = null;
    annonce.ann.fnSimple = null;
    annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = this.sanitizeString(controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb'));
    annonce.annonceur.mail = this.sanitizeString(controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb'));
    let avis: Avis = new Avis();

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.DIVE_IN];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_2;

    return avis;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}

